import { auth, db } from '../config/firebaseConfig';
import { addDoc, collection, doc, serverTimestamp, setDoc } from 'firebase/firestore';
const STORAGE_KEY = 'consent_prefs_v1';
export const CONSENT_CHANGED_EVENT = 'zedi:consent-changed';

export function getConsentPrefs() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : { analytics: false, functional: false, marketing: false, setAt: null };
  } catch {
    return { analytics: false, functional: false, marketing: false, setAt: null };
  }
}

export function setConsentPrefs(prefs) {
  const merged = { analytics: false, functional: false, marketing: false, setAt: new Date().toISOString(), ...prefs };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        analytics_storage: merged.analytics ? 'granted' : 'denied',
        ad_storage: merged.marketing ? 'granted' : 'denied',
        ad_user_data: merged.marketing ? 'granted' : 'denied',
        ad_personalization: merged.marketing ? 'granted' : 'denied'
      });
    }
  } catch {}
  try {
    window.dispatchEvent(new CustomEvent(CONSENT_CHANGED_EVENT, { detail: merged }));
  } catch {}
  void syncConsentPrefsToFirestore(merged);
  return merged;
}

async function syncConsentPrefsToFirestore(prefs) {
  try {
    const uid = auth?.currentUser?.uid;
    if (!uid) return;

    const payload = {
      policyVersion: prefs.policyVersion || 'v1',
      functional: !!prefs.functional,
      analytics: !!prefs.analytics,
      marketing: !!prefs.marketing,
      setAt: serverTimestamp(),
      setAtIso: prefs.setAt || new Date().toISOString(),
      sourceApp: 'signupwebsite',
      jurisdiction: prefs.jurisdiction || null,
      updatedAt: serverTimestamp(),
    };

    await setDoc(
      doc(db, 'zedipass_users_private', uid, 'consent', 'current'),
      payload,
      { merge: true }
    );

    await addDoc(
      collection(db, 'zedipass_users_private', uid, 'consent', 'history', 'changes'),
      {
        ...payload,
        createdAt: serverTimestamp(),
      }
    );
  } catch (_) {
    // swallow consent-sync failures to avoid blocking UX
  }
}

export function hasFunctionalConsent() {
  return !!getConsentPrefs().functional;
}

export function hasAnalyticsConsent() {
  return !!getConsentPrefs().analytics;
}

export function hasMarketingConsent() {
  return !!getConsentPrefs().marketing;
}

// Lets any "Cookie settings" link reopen the consent banner.
export const OPEN_CONSENT_EVENT = 'zedi:open-consent';
export function openConsentSettings() {
  try { window.dispatchEvent(new CustomEvent(OPEN_CONSENT_EVENT)); } catch {}
}
